import React, { Component } from "react";
import { connect } from "react-redux";
import { translate } from "react-multi-lang";
import {
  RegisterJobSeeker,
  get_education,
  get_genders,
  getSeekerType,
  getLspServices,
  getDistance,
  getConstituency,
  get_skill_education,
} from "../../actions/accountAction";
import store from "../../store";
import Validation from "../hoc/Validation";
import { getEducationLevel } from "../../actions/accountAction";
import Autocomplete from "react-autocomplete";
import ServerSetting from "../../config.json";

const COUNSELLOR = "10";
const USERTYPE = "1";
const LSP = "8";

let environment =
  typeof process.env.NODE_ENV !== "undefined" &&
    process.env.NODE_ENV === "production"
    ? "production"
    : "development";

let API_SERVER = ServerSetting[environment].API_SERVER;

class Jobseekersignup extends Component {
  constructor(props) {
    super(props);
    this.state = {
      submitStatus: false,
      gender: 2,
      user_subtype: window.location.search.split("=")[1],
      skill: window.location.search.split("=")[2],
      error: "",
      selectedCheckboxes: new Set(),
      rememberCheckboxes: new Set(),
      shareMobile: new Set(),
      capchaError: "",
      share_mobile: [],
      Education: [],
      educid: "",
      educkey: "",

      interests: [],
      selectedInterest: [],
    };
    this.capchaRef = React.createRef();
    if (this.state.skill) {
    }

    if (this.state.skill) {
      store.dispatch(get_skill_education());

    } else {
      store.dispatch(get_education());
      store.dispatch(getEducationLevel());

    }
    store.dispatch(get_genders());
    if (this.state.user_subtype && this.state.user_subtype === USERTYPE) {
      store.dispatch(getSeekerType());
      store.dispatch(getConstituency());
    }

    if (this.state.user_subtype && this.state.user_subtype === LSP) {
      store.dispatch(getLspServices());
      store.dispatch(getDistance());
    }

    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentDidMount() {
    let text = "";
    if (this.state.user_subtype === "1") {
      text = "forms.seekerSignup";
    } else if (this.state.user_subtype === "8") {
      text = "forms.lspSignup";
    } else if (this.state.user_subtype === "10") {
      text = "forms.counSignup";
    }
    document.title = this.props.t(text, { param: "react" });
    if (this.props.locationData.for_coun_register === "1") {
      this.setState({ education_level: "7" });
    }

    // ⬇️ Fetch the interest dropdown options here
    fetch(`${API_SERVER}ggr-master-interest/index`)
      .then((res) => res.json())
      .then((resJson) => {
        if (resJson.data && Array.isArray(resJson.data)) {
          this.setState({ interests: resJson.data });
        }
      })
      .catch((err) => {
        console.error("Failed to fetch interests:", err);
      });
  }

  async handleUserInput(e) {
    const name = e.target.name;
    let value = e.target.value;
    let type = e.target.type;
    let key = e.target.key;

    if (type === "text") {
      let regex = /^[A-Za-z0-9 ]+$/;
      if (!regex.test(value) && value) {
        return false;
      }
    }


    if (this.state.error && e.target.name === "gender") {
      this.setState({ error: "" });
    }
    if (name === "education_level") {
      this.setState({ educid: value });
      // this.setState({educkey:key});

    }

    if (name === "remember") {
      let rememberCheckboxes = this.state.rememberCheckboxes;
      if (rememberCheckboxes.has(value)) {
        rememberCheckboxes.delete(value);
      } else {
        rememberCheckboxes.add(value);
      }
      await this.setState({ rememberCheckboxes }, () => {
        value = Array.from(this.state.rememberCheckboxes);
      });
    }

    if (name === "subtype_id") {
      let selectedCheckboxes = this.state.selectedCheckboxes;
      if (selectedCheckboxes.has(value)) {
        selectedCheckboxes.delete(value);
      } else {
        selectedCheckboxes.add(value);
      }
      await this.setState({ selectedCheckboxes }, () => {
        value = Array.from(this.state.selectedCheckboxes);
      });
    }
    if (name === "share_mobile") {
      let shareMobile = this.state.shareMobile;
      if (shareMobile.has(value)) {
        shareMobile.delete(value);
      } else {
        shareMobile.add(value);
      }
      await this.setState({ shareMobile }, () => {
        value = Array.from(this.state.shareMobile);
      });
    }

    this.setState({ [name]: value, submitStatus: false });
  }

  handleSubmit(event) {
    event.preventDefault();

    const user = {

      interested_in: this.state.selectedInterest,
      email: this.state.email,
      firstname: this.state.firstname,
      lastname: this.state.lastname,
      mobile: this.state.mobile,
      aadhar: this.state.aadhar,
      district_id: this.state.district_id,
      password: this.state.password,
      other: this.state.other,
      education_level: this.state.education_level,
      qualification: this.state.Education.education_level_id,
      state_id: 3,
      gender: this.state.gender,
      user_subtype: this.state.user_subtype,
      communication: this.state.communication,
      subtype_id: this.state.subtype_id ? this.state.subtype_id : undefined,
      share_mobile: this.state.share_mobile.length
        ? this.state.share_mobile.toString()
        : undefined,
      constituency_id: this.state.constituency_id
        ? this.state.constituency_id
        : undefined,
      service_id: this.state.service_id,
      nearBy: this.state.nearBy,

      // subtype_id: ["2", "4", "5", "11"]
    };

    if (
      !this.state.submitStatus &&
      this.props.validator.allValid() &&
      this.state.gender
    ) {
      this.setState({ submitStatus: true });
      store.dispatch(RegisterJobSeeker(user));
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
    } else {
      this.props.validator.showMessages();
      this.forceUpdate();
      if (!this.state.gender) {
        this.setState({ error: "Gender is required" });
      }
    }
  }

  setCourses = (data, val, key, valKey) => {

    const Education = this.state.Education;
    const index = data.findIndex((d) => d.education_id === this.state.educid);
    if (index !== -1) {
      const MatchEdu = data[index].qualification.filter(
        (edu) => edu.name === val
      );
      const value = MatchEdu && MatchEdu.length ? MatchEdu[0].id : "";
      Education[key] = val === "Others" ? "152" : value;
      Education[valKey] = val;
      this.setState({ Education, submitted: false });
    }
  };

  createDistoption = () => {
    let Mainprops = this.props;
    let Distoption = [];
    if (Mainprops.actionReducer.selectedDistricts.length > 0) {
      Mainprops.actionReducer.selectedDistricts.map(function (data) {
        if (data.state_name === "Punjab") {
          data.dist.map(function (distdata, distindex) {
            Distoption.push(
              <option key={distindex} value={distdata.id}>
                {distdata.name}
              </option>
            );
            return Distoption;
          });
        }
        return Distoption;
      });
    }
    return Distoption;
  };

  render() {
    let courses = [];
    const { Education } = this.state;
    let Mainprops = this.props;
    const { validator } = this.props;
    const { error, user_subtype } = this.state;
    const serviceList = this.props.actionReducer.Services;
    let Mainthis = this;
    let Mainstate = this.state;
    let data = Mainprops.actionReducer.educationLevel;


    if (this.state.educid) {
      const selectedEducation = data.filter(
        (edu) => edu.education_id === this.state.educid
      );
      if (selectedEducation && selectedEducation[0]) {
        selectedEducation &&
          selectedEducation[0] &&
          selectedEducation[0].qualification.forEach((qual) => {
            courses.push({ label: qual.name, id: qual.id });

          });
      }
    }
    courses.push({ label: "Others", id: "152" });

    if (user_subtype === COUNSELLOR) {
      const filterEdu = [];
      data.forEach((edu, ind) => {
        if (ind >= 8) {
          filterEdu.push(edu);
        }
      });
      data = filterEdu;
    } else if (this.state.skill === 1) {
      const filterEdu = [];

      data.forEach((edu, ind) => {
        if (ind >= 1) {
          filterEdu.push(edu);
        }
      });
      data = filterEdu;
    }
    let constituency = [];
    if (this.state.district_id) {
      constituency = this.props.actionReducer.constituency.filter(
        (data) => data.district_id === this.state.district_id
      );
    }

    return (
      <div className="m-1 registrationFormDiv">
        <span id="registration-form" class="sr-only">Registration Form</span>
        <form
          onSubmit={this.handleSubmit}
          aria-labelledby="registration-form"
          role="form"
          name="registrationForm"
        >
          <div className="form-group">
            <div className="row">
              <div className="col-sm-12 text-left">
                <label htmlFor="firstname" id="firstnameLabel">
                  {this.props.t("register_user.user_fname", { param: "react" })}
                  <span className="errorclr ml-2" aria-hidden="true">*</span>
                </label>
                <input
                  autoComplete="first-name"
                  type="text"
                  onChange={(event) => this.handleUserInput(event)}
                  placeholder={this.props.t("forms.enterFname", { param: "react" })}
                  value={this.state.firstname || ""}
                  className="form-control"
                  id="firstname"
                  name="firstname"
                  aria-label="Enter firstname"
                  // required
                  aria-required="true" firstnameLabel
                  // aria-describedby="firstnameHelp firstnameLabel"
                  aria-describedby="firstnameLabel"
                  autocomplete="given-name"
                />
                {validator.message("First name", this.state.firstname, "required|max:50|alpha")}
              </div>
            </div>
          </div>

          <div className="form-group">
            <div className="row">
              <div className="col-sm-12 text-left">
                <label htmlFor="lastname" id="lastnameLabel">
                  {this.props.t("register_user.user_lname", { param: "react" })}
                </label>
                <input
                  autoComplete="last-name"
                  type="text"
                  placeholder={this.props.t("forms.enterLname", { param: "react" })}
                  onChange={(event) => this.handleUserInput(event)}
                  value={this.state.lastname || ""}
                  className="form-control"
                  id="lastname"
                  name="lastname"
                  aria-label="Enter last name"
                  // aria-describedby="lastnameHelp lastnameLabel"
                  aria-describedby="lastnameLabel"
                  aria-required="true"
                />
                {validator.message("last name", this.state.lastname, "max:50|alpha")}
              </div>
            </div>
          </div>

          <div className="form-group">
            <fieldset>
              <label id="genderLegend" className="d-block">
                <h1 className="mb-3 fs20px"> {this.props.t("register_user.gender", { param: "react" })}
                  <span className="errorclr ml-2" aria-hidden="true">*</span></h1>
              </label>
              {Mainprops.actionReducer.Genders.length > 0 &&
                Mainprops.actionReducer.Genders.map((data, index) => (
                  <div className="form-check-inline" key={index}>
                    <input
                      type="radio"
                      onChange={(event) => Mainthis.handleUserInput(event)}
                      className="form-check-input"
                      id={`gender_${data.id}`}
                      name="gender"
                      value={data.id}
                      checked={parseInt(Mainthis.state.gender) === parseInt(data.id)}
                      aria-labelledby={`genderLabel_${data.id}`}
                      // required
                      aria-required="true"
                      aria-label="Select gender"
                    />
                    <label
                      className="form-check-label"
                      htmlFor={`gender_${data.id}`}
                      id={`genderLabel_${data.id}`}
                    >
                      {/* {data.name} */}
                      {this.props.t(`profileDetails.genders.${data.name.toLowerCase()}`)}
                    </label>
                  </div>
                ))}
              {error && <span className="errorclr">{error}</span>}
            </fieldset>
          </div>

          <div className="form-group">
            <div className="row">
              <div className="col-sm-12 text-left">
                <label htmlFor="education_level" id="educationLabel">
                  {this.props.t("register_user.education", { param: "react" })}
                  <span className="errorclr ml-2" aria-hidden="true">*</span>
                </label>
                <select
                  className="form-control"
                  id="education_level"
                  name="education_level"
                  aria-label="Select Education Level"

                  onChange={(event) => {
                    this.setState({ Education: [] });
                    this.handleUserInput(event);
                  }}
                  disabled={this.props.locationData.for_coun_register === "1"}
                  // required
                  aria-required="true"
                  aria-labelledby="educationLabel"
                >
                  <option value="">
                    {this.props.t("forms.selectEdu", { param: "react" })}
                  </option>
                  {data &&
                    data.map((data, index) => (
                      <option value={data.education_id} key={index}>
                        {data.education_name}
                      </option>
                    ))}
                </select>
                {validator.message("education level", this.state.education_level, "required")}
              </div>
            </div>
          </div>

          <div className="form-group position-relative">
            <div className="row">
              <div className="col-sm-12 text-left">
                <label
                  htmlFor="education_autocomplete"
                  id="educationAutoLabel"
                  title={this.props.t("profileDetails.educationDesc", { param: "react" })}
                >
                  {this.props.t("education.course_registration", { param: "react" })}
                  <span className="errorclr ml-2" aria-hidden="true">*</span>
                </label>
              </div>
              <div className="col-sm-12 test" id="courseAuto">
                <img
                  src="/images/down-arrow.png"
                  alt="select course"
                  className="arrowAbsolute"
                  aria-hidden="true"
                />

                <Autocomplete
                  items={courses}
                  shouldItemRender={(item, value) =>
                    item.label.toLowerCase().includes(value.toLowerCase())
                  }
                  menuStyle={{
                    zIndex: "9",
                    border: "1px solid #ccc",
                    overflowY: "scroll",
                    boxShadow: "1px 2px 10px #ccc",
                    padding: "4px",
                    maxHeight: "123px",
                    fontSize: "14px",
                    left: 10
                  }}
                  renderInput={(props) => {
                    return (
                      <input
                        autoComplete="education"
                        className="form-control"
                        {...props}
                        id="education_autocomplete"
                        name="education_autocomplete"

                        aria-required="true"
                        aria-labelledby="educationAutoLabel"
                        aria-label="Enter education"
                      />
                    );
                  }}
                  wrapperStyle={{ width: "100%" }}
                  renderItem={(item, isHighlighted) => (
                    <div
                      key={item.id}
                      style={{
                        background: isHighlighted ? "lightgray" : "white",
                        borderBottom: "1px solid #ccc",
                      }}
                      role="option"
                      aria-selected={isHighlighted}
                    >
                      {item.label}
                    </div>
                  )}
                  value={
                    Mainstate.Education.education_level_id_value || ""
                  }
                  onChange={(e) =>
                    this.setCourses(
                      data,
                      e.target.value,
                      "education_level_id",
                      "education_level_id_value"
                    )
                  }
                  getItemValue={(item) => item.label}
                  onSelect={(val) =>
                    this.setCourses(
                      data,
                      val,
                      "education_level_id",
                      "education_level_id_value"
                    )
                  }
                />

                {validator.message(
                  "course",
                  this.state.Education.education_level_id_value,
                  "required"
                )}
              </div>
            </div>
          </div>

          <div className="form-group">
            <div className="row">
              <div className="col-sm-12 text-left">
                <label htmlFor="other">{this.props.t("register_user.other", { param: "react" })}</label>
                <input
                  autoComplete="other"
                  type="text"
                  onChange={(event) => this.handleUserInput(event)}
                  className="form-control"
                  name="other"
                  id="other"
                  aria-label="Enter other"
                />
              </div>
            </div>
          </div>

          <div className="form-group">
            <div className="row">
              <div className="col-sm-12 text-left">
                <label htmlFor="district_id">
                  {this.props.t("register_user.district", { param: "react" })}
                  <span className="errorclr ml-2">*</span>
                </label>


                <select
                  className="form-control"
                  id="district_id"
                  onChange={(event) => this.handleUserInput(event)}
                  name="district_id"
                  aria-label="Select District"
                  aria-required="true"
                >
                  <option value={""}>
                    {this.props.t("profileDetails.selectDistrict", {
                      param: "react",
                    })}
                  </option>
                  {this.createDistoption()}
                </select>
                {validator.message(
                  "district",
                  this.state.district_id,
                  "required"
                )}
              </div>
            </div>
          </div>

          {user_subtype && user_subtype === USERTYPE ? (
            <div className="form-group">
              <div className="row">
                <div className="col-sm-12 text-left">
                  <label htmlFor="constituency_id">
                    {this.props.t("register_user.constituency", {
                      param: "react",
                    })}
                  </label>
                  <select
                    className="form-control"
                    onChange={(event) => this.handleUserInput(event)}
                    name="constituency_id"
                    aria-label="Select Constituency"
                    aria-required="true"
                  >
                    <option value={""}>
                      {this.props.t("profileDetails.selectConstituency", {
                        param: "react",
                      })}
                    </option>
                    {constituency.length > 0 &&
                      constituency.map(function (data, index) {
                        return (
                          <option key={index} value={data.id}>
                            {data.name}
                          </option>
                        );
                      })}
                  </select>
                </div>
              </div>
            </div>
          ) : null}

          <div className="form-group">
            <div className="row">
              <div className="col-sm-12 text-left">
                <label htmlFor="email">
                  {this.props.t("register_user.email", { param: "react" })}
                  <span className="errorclr ml-2">*</span>
                </label>
                <input
                  autoComplete="email"
                  type="email"
                  onChange={(event) => this.handleUserInput(event)}
                  className="form-control"
                  placeholder={this.props.t("forms.egEmail", {
                    param: "react",
                  })}
                  name="email"
                  aria-label="Enter email"
                  aria-required="true"

                />
                {validator.message("email", this.state.email, "email|required")}
              </div>
            </div>
          </div>

          <div className="form-group">
            <div className="row">
              <div className="col-sm-12 text-left">
                <p htmlFor="mobile" className="mb-2">
                  {this.props.t("register_user.mobile", { param: "react" })}
                  <span className="errorclr ml-2">*</span>
                </p>

                <span id="mobileLabel" class="sr-only visually-hidden">
                  Mobile Number
                </span>

                <input
                  onChange={(event) => this.handleUserInput(event)}
                  type="tel"
                  className="form-control"
                  placeholder={this.props.t("forms.10mobile", {
                    param: "react",
                  })}
                  name="mobile"
                  id="mobile"
                  aria-required="true"
                  aria-describedby="mobileError"
                  aria-labelledby="mobileLabel"
                  autoComplete="tel"
                />

                <div id="mobileError" class="error-message" style={{ fontSize: '12px', fontWeight: 'bold', color: '#000' }}>
                  Please enter a valid 10-digit mobile number.
                </div>

                {validator.message(
                  "mobile",
                  this.state.mobile,
                  "required|phone"
                )}

              </div>
            </div>
          </div>


          {user_subtype === LSP ? (
            <>
              <div className="form-group">
                <div className="row">
                  <div className="col-sm-12 text-left">
                    <label htmlFor="service_id">
                      {this.props.t("register_user.selectService", {
                        param: "react",
                      })}
                      <span className="errorclr ml-2">*</span>
                    </label>
                    <select
                      className="form-control"
                      id="service_id"
                      name="service_id"
                      aria-required="true"
                      onChange={(event) => this.handleUserInput(event)}
                      aria-label="Select Service"
                    >
                      <option value="">
                        {this.props.t("placeholder.select", {
                          param: "react",
                        }) +
                          " " +
                          this.props.t("lsp_user.service_name", {
                            param: "react",
                          })}
                      </option>
                      {serviceList &&
                        serviceList.length > 0 &&
                        serviceList.map(function (data, index) {
                          return (
                            <option key={index} value={data.category_id}>
                              {data.category_name}
                            </option>
                          );
                        })}
                    </select>
                    {validator.message(
                      "service name",
                      this.state.service_id,
                      "required"
                    )}
                  </div>
                </div>
              </div>
              <div className="form-group">
                <div className="row">
                  <div className="col-sm-12 text-left">
                    <label htmlFor="nearBy">
                      {this.props.t("register_user.area_of_operation", {
                        param: "react",
                      })}
                      <span className="errorclr ml-2">*</span>
                    </label>
                    <select
                      className="form-control"
                      name="nearBy"
                      id="nearBy"
                      aria-label="Area of Operation"
                      aria-required="true"
                      onChange={(e) => this.handleUserInput(e)}
                    >
                      <option value="">
                        {this.props.t("placeholder.select", {
                          param: "react",
                        }) +
                          " " +
                          this.props.t("register_user.area_of_operation", {
                            param: "react",
                          })}
                      </option>
                      {this.props.actionReducer.distance &&
                        this.props.actionReducer.distance.length
                        ? this.props.actionReducer.distance.map((dist, key) => {
                          return (
                            <option key={key} value={dist.id}>
                              {dist.name}
                            </option>
                          );
                        })
                        : null}
                    </select>
                    {validator.message(
                      "area of operation",
                      this.state.nearBy,
                      "required"
                    )}
                  </div>
                </div>
              </div>
            </>
          ) : null}

          {USERTYPE && user_subtype === USERTYPE ?
            <div className="form-group">
              <div className="row">
                <div className="col-sm-12 text-left">
                  <label htmlFor="interestSelect" className="">
                    {this.props.t("register_user.interested_in", {
                      param: "react",
                    })}
                    <span className="errorclr ml-2">*</span>
                  </label>

                  {/* Checkbox group */}
                  <div className="dropdown">
                    <button
                      aria-label="Select Interests"
                      type="button"
                      className="btn btn-light form-shadow dropdown-toggle sfderf"
                      onClick={() =>
                        this.setState((prev) => ({ showDropdown: !prev.showDropdown }))
                      }
                      style={{ width: "100%", textAlign: "left" }}
                    >
                      {this.state.selectedInterest.length > 0
                        ? (() => {
                          const selectedItems = this.state.interests.filter((i) =>
                            this.state.selectedInterest.includes(i.id)
                          );
                          const names = selectedItems.map((i) => i.name);

                          // ✅ Show first name + count
                          if (names.length > 1) {
                            return `${names[0]} +${names.length - 1}`;
                          }
                          return names[0]; // only one selected
                        })()
                        : this.props.t("profileDetails.selectInterest", {
                          param: "react",
                        })
                      }
                    </button>

                    {/* Dropdown content (checkbox list) */}
                    {this.state.showDropdown && (
                      <div
                        className="dropdown-menu show p-2"
                        style={{ border: "1px solid #ccc", borderRadius: "5px", width: "100%", maxHeight: "200px", overflowY: "auto", }}
                      >
                        {this.state.interests.map((item) => (
                          <div
                            key={item.id}
                            className="form-check"

                          >
                            <input
                              type="checkbox"
                              className="form-check-input"
                              aria-label={`Select interest: ${item.name}`}
                              id={`interest-${item.id}`}
                              value={item.id}
                              checked={this.state.selectedInterest.includes(item.id)}
                              disabled={
                                // disable if already 3 selected and this one is not part of them
                                this.state.selectedInterest.length >= 3 &&
                                !this.state.selectedInterest.includes(item.id)
                              }
                              onChange={(e) => {
                                let selected = [...this.state.selectedInterest];
                                if (e.target.checked) {
                                  if (selected.length < 3) {
                                    selected.push(item.id);
                                  }
                                } else {
                                  selected = selected.filter((val) => val !== item.id);
                                }
                                this.setState({ selectedInterest: selected });
                              }}
                            />
                            <label className="form-check-label" htmlFor={`interest-${item.id}`}>
                              {item.name}
                            </label>
                          </div>
                        ))}
                      </div>
                    )}
                  </div>

                  {validator.message(
                    "interest",
                    this.state.selectedInterest,
                    "required"
                  )}
                </div>
              </div>
            </div>
            : ""}

          {user_subtype !== LSP ? (
            <div className="form-group">
              <div className="col-sm-12 text-left">
                <div className="row">
                  <div className="col-sm-12">
                    <label className={"col-md-12 p-0"}>
                      {this.props.t("register_user.communication", {
                        param: "react",
                      })}
                      <span className="errorclr ml-2">*</span>
                    </label>
                    <div className="form-check-inline">
                      <label className="form-check-label" htmlFor="radio1">
                        <input
                          type="radio"
                          onChange={(event) => Mainthis.handleUserInput(event)}
                          className="form-check-input"
                          name="communication"
                          aria-label="Select communication preference: Yes"
                          value={"1"}
                          checked={Mainthis.state.communication === "1"}
                        />
                        {this.props.t("profileDetails.yes", { param: "react" })}
                      </label>
                    </div>
                    <div className="form-check-inline">
                      <label className="form-check-label" htmlFor="radio1">
                        <input
                          type="radio"
                          onChange={(event) => Mainthis.handleUserInput(event)}
                          className="form-check-input"
                          name="communication"
                          value={"0"}
                          aria-label="Select communication preference: No"
                          checked={Mainthis.state.communication === "0"}
                        />
                        {this.props.t("profileDetails.no", { param: "react" })}
                      </label>
                    </div>
                  </div>
                </div>
              </div>
              {validator.message(
                "communication",
                this.state.communication,
                "required"
              )}
            </div>
          ) : null}

          {user_subtype === LSP ? (
            <div className="form-group">
              <div className="row">
                <div className="col-sm-12 ml-2">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    name="share_mobile"
                    id="share_mobile"
                    value="1"
                    aria-label="Share mobile number"
                    aria-describedby="shareMobileHelp"
                    onClick={(e) => this.handleUserInput(e)}
                  />
                  {/* {this.props.t("register_user.share_mobile", {
                    param: "react",
                  })}
  */}

                  <label className="form-check-label" htmlFor="share_mobile">
                    {this.props.t("register_user.share_mobile", {
                      param: "react",
                    })}

                    <span className="errorclr ml-2">*</span>
                  </label>
                </div>
              </div>
            </div>
          ) : null}

          {user_subtype &&
            user_subtype === USERTYPE &&
            this.props.actionReducer.seekerType.length && (
              <div className="form-group">
                <div className="row">
                  <div className="col-sm-12 text-left">
                    <label className={"col-md-12 p-0"}>
                      {this.props.t("register_user.selectType", {
                        param: "react",
                      })}
                    </label>
                    <div className={"d-inline"}>
                      {this.props.actionReducer.seekerType &&
                        this.props.actionReducer.seekerType.length
                        ? this.props.actionReducer.seekerType.map(
                          (types, key) => {
                            return (
                              <div className="form-check" key={key}>
                                <label
                                  className="form-check-label"
                                  htmlFor="check1"
                                >
                                  <input
                                    onClick={(event) =>
                                      this.handleUserInput(event)
                                    }
                                    type="checkbox"
                                    className="form-check-input"
                                    name="subtype_id"
                                    aria-label="Enter subtype"
                                    value={types.id}
                                  />
                                  {types.name}
                                </label>
                              </div>
                            );
                          }
                        )
                        : ""}
                    </div>
                  </div>
                </div>
              </div>
            )}

          <div className="form-group">
            <div className="row">
              <div className="col-sm-12 ml-2">

                <div className="form-check d-flex align-items-center">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    id="remember"
                    name="remember"
                    aria-required="true"
                    aria-describedby="rememberError"
                    onClick={(e) => this.handleUserInput(e)}
                  />

                  <label htmlFor="remember" className="form-check-label">
                    {this.props.t('register_user.terms', { param: 'react' })}
                    <span className="errorclr ml-2">*</span>
                  </label>

                  <div className="valid-feedback">Valid.</div>

                  {/* Add an id for the error message so aria-describedby works */}
                  <div id="rememberError" className="invalid-feedback">
                    Check this checkbox to continue.
                  </div>
                </div>


                {/* <input
                  className="form-check-input"
                  type="checkbox"
                  id="remember"
                  name="remember"
                  aria-label="Remember me"
                  aria-required="true"
                  aria-describedby="rememberError"
                  onClick={(e) => this.handleUserInput(e)}
                />

                <label htmlFor="remember" className="form-check-label">
                  {this.props.t('register_user.terms', { param: 'react' })}
                  <span className="errorclr ml-2">*</span>
                </label>
                <div className="valid-feedback">Valid.</div>
                <label className="invalid-feedback">
                  Check this checkbox to continue.
                </label> */}
              </div>
              <div className="row">
                {validator.message(
                  "terms and conditions",
                  this.state.remember,
                  "required"
                )}
              </div>

              <div className="row">
                <div className="col-sm-12">
                  <button
                    aria-label="Submit registration form"
                    type="submit"
                    className="btn btn-primary btn-primary2  mt-3"
                  >
                    {this.props.t("profileDetails.submit", { param: "react" })}
                  </button>
                </div>
              </div>
            </div>
          </div>

        </form>
      </div>
    );
  }
}
const mapStateToProps = (store) => {
  return store;
};

export default connect(mapStateToProps)(translate(Validation(Jobseekersignup)));